import { PanelBody, RangeControl, ToggleControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Mark shape — bar thickness, donut hole, line smoothing, markers, animation.
 */
export default function MarkControls( { attributes, setAttributes, config } ) {
	const isBar = 'bar' === config.type;
	const isLine = 'line' === config.type || 'area' === config.type;
	const isDonut = 'donut' === config.type;

	return (
		<PanelBody
			title={ __( 'Marks', 'brandy-blocks' ) }
			initialOpen={ false }
		>
			{ isBar && (
				<RangeControl
					__nextHasNoMarginBottom
					label={ __( 'Bar thickness (px)', 'brandy-blocks' ) }
					help={ __(
						'A cap, not a width — bars never fill their slot, and the leftover is what keeps the chart from reading as a wall.',
						'brandy-blocks'
					) }
					value={ attributes.barMaxThickness }
					min={ 4 }
					max={ 64 }
					onChange={ ( value ) =>
						setAttributes( { barMaxThickness: value ?? 24 } )
					}
				/>
			) }

			{ isDonut && (
				<RangeControl
					__nextHasNoMarginBottom
					label={ __( 'Hole size (%)', 'brandy-blocks' ) }
					help={ __(
						'From 35% up, the hole carries the total.',
						'brandy-blocks'
					) }
					value={ attributes.donutHole }
					min={ 10 }
					max={ 85 }
					onChange={ ( value ) =>
						setAttributes( { donutHole: value ?? 55 } )
					}
				/>
			) }

			{ isLine && (
				<>
					<ToggleControl
						__nextHasNoMarginBottom
						label={ __( 'Smooth the line', 'brandy-blocks' ) }
						help={ __(
							'A curve invents values between the points. Use it for a shape, not for data a reader will measure.',
							'brandy-blocks'
						) }
						checked={ !! attributes.smoothLine }
						onChange={ ( value ) =>
							setAttributes( { smoothLine: value } )
						}
					/>
					<ToggleControl
						__nextHasNoMarginBottom
						label={ __( 'Point markers', 'brandy-blocks' ) }
						checked={ !! attributes.showMarkers }
						onChange={ ( value ) =>
							setAttributes( { showMarkers: value } )
						}
					/>
				</>
			) }

			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Animate on scroll', 'brandy-blocks' ) }
				help={ __(
					'Plays once when the chart comes into view, and is skipped for readers who ask for reduced motion. The values never depend on it.',
					'brandy-blocks'
				) }
				checked={ !! attributes.animate }
				onChange={ ( value ) => setAttributes( { animate: value } ) }
			/>
		</PanelBody>
	);
}
